import { Endpoint } from '../endpoint';
import { CommissionPeriodResponse, CommissionPeriodId, CommissionPeriodItemResponse } from '@business/entities/commission';

export function fetchPeriods() {
  return Endpoint.get<CommissionPeriodResponse[]>(`@gc/commission-period`);
}

export function fetchPeriod(id: CommissionPeriodId, dateRange: string) {
  return Endpoint.get<CommissionPeriodResponse>(`@gc/commission-period/period/${id}`, { params: { dateRange } });
}

export function downloadPeriod(id: CommissionPeriodId, dateRange: string, filename: string) {
  return Endpoint.get<void>(`@gc/commission-period/download-period/${id}`, { params: { dateRange }, isFile: true, filename });
}

export function fetchDetails(periodId: CommissionPeriodId, userId: string, dateRange: string) {
  return Endpoint.get<CommissionPeriodItemResponse[]>(`@gc/commission-period/details/${periodId}`, { params: { userId, dateRange } });
}

export function downloadDetails(periodId: CommissionPeriodId, userId: string, dateRange: string, filename: string) {
  return Endpoint.get<void>(`@gc/commission-period/download/${periodId}`, { params: { userId, dateRange }, isFile: true, filename });
}
